import * as React from 'react';
import { FC } from 'react';

import { useRoutesDisplayBottomService as useRoutesDisplayServiceNotification } from 'components/top-service-mode/hooks/use-routes-display-top-service';
import { useRoute } from 'hooks/navigation/use-route';
import { routes } from 'utils/routing';

import { useServiceModeNotification } from './hooks/use-service-mode-notification';
import TopServiceModeNotificationView from './top-service-mode-notification.view';
import { ITopServiceModeNotificationProps } from './types';

const StickyServiceNotification = TopServiceModeNotificationView.withConfig({
  zIndex: Styles.zIndex.overlay + 100,
  width: 'full',
});

/**
 *
 * TopServiceModeNotification purpose
 *
 */
const TopServiceModeNotification: FC<React.PropsWithChildren<
  ITopServiceModeNotificationProps
>> = () => {
  const showServiceNotificationOnRoutes = useRoutesDisplayServiceNotification();
  const topServiceModeNotificationDetails = useServiceModeNotification();
  const { pathname } = useRoute();

  if (!showServiceNotificationOnRoutes && pathname !== routes.base) {
    return null;
  }

  return (
    topServiceModeNotificationDetails && (
      <StickyServiceNotification {...topServiceModeNotificationDetails} />
      // <CancellationModal /> Logic will be done in the FAB button work
    )
  );
};

export default TopServiceModeNotification;
